import { render } from "./LastDashboardRefresh.vue?vue&type=template&id=c5687094"
import script from "./LastDashboardRefresh.vue?vue&type=script&lang=js"
export * from "./LastDashboardRefresh.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__